import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { useMerchant } from "@auth";
import { getCustomerMetadata, useBranches } from "@api";
import { useAiFeatures } from "@flags";
import { useCustomerGroups } from "@context/CustomerGroupsContext";
import { usePaymentProfilesContext } from "@context/PaymentProfilesContext";
import { useIsBranchScoped } from "../../trade-accounts/branchScope";
import { buildFields } from "./workingSetBuilder";

// The builder's fields for this merchant, from the same sources the Trade Accounts columns use.
export const useBuilderFields = () => {
  const { merchant } = useMerchant();
  const { groups } = useCustomerGroups();
  const { profiles: paymentProfiles } = usePaymentProfilesContext();
  const { data: branches = [] } = useBranches();
  const isBranchScoped = useIsBranchScoped();
  const showFacts = useAiFeatures();
  const { data: metadata } = useQuery({
    queryKey: ["customerMetadata", merchant?.id],
    queryFn: getCustomerMetadata,
    enabled: !!merchant?.id,
    staleTime: 5 * 60_000,
  });

  return useMemo(
    () => buildFields({ merchant, metadata, groups, paymentProfiles, branches, isBranchScoped, showFacts }),
    [merchant, metadata, groups, paymentProfiles, branches, isBranchScoped, showFacts],
  );
};
